import service from '@/services/coupons';
import { toastDebounced } from '@/helpers/toasts';

export default {
  loadCoupons({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit('setLoadingCoupons', true);
      // Do something here... lets say, a http call using vue-resource
      service
        .getCoupons(state.allCoupons.pagination)
        .then(
          response => {
            commit('loadCouponsSuccess', response);
            resolve(response);
          },
          error => {
            // http failed, let the calling function know that action did not work out

            reject(error);
          }
        )
        .finally(() => {
          commit('setLoadingCoupons', false);
          resolve('done');
        });
    });
  },

  checkCouponName({ commit, state }, payload) {
    commit('setLoadingCouponNameCheck', true);

    return service
      .checkCouponNameUnique({
        couponType: payload.couponType,
        couponName: payload.couponName,
      })
      .then(response => {
        commit('loadCouponNameExists', response);
        if (!state.newCoupon.couponNameExists) {
          commit('nextStep');
        }
      })
      .finally(() => {
        commit('setLoadingCouponNameCheck', false);
      });
  },
  deleteCoupon({ commit, dispatch }, payload) {
    return service.deleteCoupon(payload.id).finally(() => {
      commit('setLoadingCreatingCoupon', false);
      dispatch('loadCoupons');
    });
  },
  addCoupon({ commit, dispatch }, payload) {
    return service.addCoupon(payload).finally(() => {
      commit('setLoadingCreatingCoupon', false);
      dispatch('loadCoupons');
    });
  },
  rulesWhenToOfferSearch({ commit }, payload) {
    return service.rulesWhenToOfferSearchProducts(payload).then(res => {
      commit('setCouponProducts', res);
    });
  },

  rulesCustomerSearchProducts({ commit }, payload) {
    return service.rulesCustomerSearchProducts(payload).then(res => {
      commit('setCouponSearchProducts', res);
    });
  },
  showToast(_, toast) {
    toastDebounced(toast);
  },
};
